<!-- Error page-->
<div class="misc-wrapper">
  <!-- Brand logo-->
  <a
    class="brand-logo d-none d-lg-flex"
    routerLink="/">
    <img
      [src]="logoService.logoPath"
      alt="brand-logo"
      height="75px" />
  </a>
  <!-- /Brand logo-->
  <div class="misc-inner p-2 p-sm-3">
    <div class="w-100 text-center">
      <h2 class="mb-1">Seite nicht gefunden 🕵🏻‍♀️</h2>
      <p class="mb-2">Ups! Die angeforderte Seite existiert leider nicht.</p>
      <button
        class="btn btn-primary mb-2 btn-sm-block"
        rippleEffect
        routerLink="/">
        Zurück zum Startbildschirm
      </button>
      <img
        [src]="
          coreConfig.layout.skin === 'dark' ? 'assets/images/pages/error-dark.svg' : 'assets/images/pages/error.svg'
        "
        alt="Error page"
        class="img-fluid" />
    </div>
  </div>
</div>
<!-- / Error page-->
